import { UI } from "@/data/content";

export default function Marquee({ lang }) {
  const chunk = UI[lang].marquee.repeat(6);
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-[#7E2438]/25 bg-[#180F12] py-5 select-none">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((i) => (
          <span key={i} className="font-serif italic text-xl sm:text-2xl text-[#A89A9E] pr-2">
            {chunk}
            <span className="text-[#B03A52] not-italic">·</span>
          </span>
        ))}
      </div>
    </div>
  );
}
